/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
* */

import DialogBox from "./DialogBox";

export default DialogBox;
